import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ServiceProvider } from './hooks/useServices';
import { AuthInitializer } from './components/AuthInitializer';
import { ThemeProvider } from './components/ThemeProvider';
import { router } from './routes';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthInitializer>
        <ServiceProvider>
          <RouterProvider router={router} />
        </ServiceProvider>
      </AuthInitializer>
    </ThemeProvider>
  </StrictMode>
);
